import React from "react"
import Pagination from "@material-ui/lab/Pagination"

export interface PaginateProps {
    totalPages: number
    currentPage: number
    callback: (newPage: number) => void
}
export const Paginate: React.FunctionComponent<PaginateProps> = props => {
    const { totalPages, currentPage, callback } = props

    return (
        <Pagination
            data-testid="pagination"
            count={totalPages}
            page={currentPage}
            variant="outlined"
            shape="rounded"
            onChange={(e: any, newPage: number) => {
                callback(newPage)
            }}
        />
    )
}
